import { encode as base64_encode } from "base-64";
import { getCookie, logout } from "./CommonFuntions";

export const namazBaseURL = process.env.REACT_APP_Namaz_URL;
export const baseURL = process.env.REACT_APP_Base_URL;
export const ImageBaseURL = process.env.REACT_APP_Image_URL;
let username = process.env.REACT_APP_UserName_Basic;
let password = "6*C$q&3cd";


export const getNamazApi = async (query) => {
  let response = await fetch(namazBaseURL + query, {});
  return response;
};

const newBaseUrl = () => {
  if (window.location.protocol === "http:") {
    let newBaseUrl = baseURL;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseURL;
  }
};

const getResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      logout("network");
    }
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  return response.json();
};

export const GetApi = async (apiName) => {
  try {
    let sessionId = global.token;
    let response = await fetch(`${newBaseUrl()}${apiName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + base64_encode(username + ":" + password),
        sessionid: sessionId ? sessionId : null,
      },
    });
    return getResponse(response);
  } catch (error) {
    throw error;
  }
};

export const PostApi = async (body, apiName) => {
  try {
    let sessionId = global.token;
    let response = await fetch(`${newBaseUrl()}${apiName}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + base64_encode(username + ":" + password),
        sessionid: sessionId ? sessionId : null,
      },
      body: JSON.stringify(body),
    });
    return getResponse(response);
  } catch (error) {
    throw error;
  }
};

export const fetchGetAuthHttp = async (apiName, token) => {
  try {
    let response = await fetch(`${newBaseUrl()}${apiName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return getResponse(response);
  } catch (error) {
    throw error;
  }
};

export const generateTokenPost = async (apiName) => {
  try {
    let response = await fetch(`${newBaseUrl()}${apiName}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer`,
      },
      body: JSON.stringify({
        username: process.env.REACT_APP_UserName,
        password: process.env.REACT_APP_Password,
      }),
    });
    return getResponse(response);
  } catch (error) {
    throw error;
  }
};
